import React from 'react';

import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';

import { i18n as whiteboardI18n } from './PromptWhiteboard.tsx';
import { PromptContent } from './PromptContent.tsx';
import { usePageAnalyticsAttributes } from './usePageAnalyticsAttributes.ts';

export interface WhiteboardNudgeContentProps {
	competitorName: string;
	linkType?: string;
	editorAppearance?: string;
	displayImportCta: boolean;
	onClickAction: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => Promise<void>;
	onDismiss: () => void;
}

export const WhiteboardNudgeContent: React.FC<WhiteboardNudgeContentProps> = ({
	competitorName,
	linkType,
	editorAppearance,
	displayImportCta,
	onClickAction,
	onDismiss,
}) => {
	const pageAnalyticsAttributes = usePageAnalyticsAttributes();

	// Determine content based on import CTA
	const descriptionText = displayImportCta
		? whiteboardI18n.descriptionImportWhiteboard
		: whiteboardI18n.descriptionDefaultWhiteboard;

	const ctaText = displayImportCta
		? whiteboardI18n.createButtonImportWhiteboard
		: whiteboardI18n.createButtonDefaultWhiteboard;

	return (
		<PromptContent
			titleText={whiteboardI18n.titleWhiteboard}
			descriptionText={descriptionText}
			ctaText={ctaText}
			dismissText={whiteboardI18n.dismissButton}
			contentIcon={WhiteboardIcon}
			iconColor="tealBold"
			iconAltText={whiteboardI18n.whiteboardIconAltText}
			onClickAction={onClickAction}
			contentType="whiteboard"
			onDismiss={onDismiss}
			competitorName={competitorName}
			linkType={linkType}
			editorAppearance={editorAppearance}
			pageAnalyticsAttributes={pageAnalyticsAttributes}
		/>
	);
};
